var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38906 11.2528C9.28906 11.2428 9.16906 11.2428 9.05906 11.2528C6.67906 11.1728 4.78906 9.22281 4.78906 6.82281C4.78906 4.37281 6.76906 2.38281 9.22906 2.38281C11.6791 2.38281 13.6691 4.37281 13.6691 6.82281C13.6591 9.22281 11.7691 11.1728 9.38906 11.2528Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6378 4.38281C18.5778 4.38281 20.1378 5.95281 20.1378 7.88281C20.1378 9.77281 18.6378 11.3128 16.7678 11.3828C16.6878 11.3728 16.5978 11.3728 16.5078 11.3828",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38922 14.9428C1.96922 16.5628 1.96922 19.2028 4.38922 20.8128C7.13922 22.6528 11.6492 22.6528 14.3992 20.8128C16.8192 19.1928 16.8192 16.5528 14.3992 14.9428C11.6592 13.1128 7.14922 13.1128 4.38922 14.9428Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5684 20.3828C19.2884 20.2328 19.9684 19.9428 20.5284 19.5128C22.0884 18.3428 22.0884 16.4128 20.5284 15.2428C19.9784 14.8228 19.3084 14.5428 18.5984 14.3828",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact_us.114257bc2c308b96c438030545f5b669.svg";
export { ForwardRef as ReactComponent };